// extracted by mini-css-extract-plugin
export default {"wrap":"HomeTabWrapper_wrap__KU0JI","wrapper":"HomeTabWrapper_wrapper__zJYD3"};